<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ct"><a class="page" id="pviii"></a><a class="page" id="pix"></a>Contents</h1>
<p class="tocfmf"><a class="xref" href="#/chiBertoloniMeli0008#pref">Preface</a></p>
<p class="tocfm"><a class="xref" href="#/chiBertoloniMeli0009#intro">Introduction: Bodies, Diseases, Images</a></p>
<p class="tocf"><a class="xref" href="#/chiBertoloniMeli0010#ch01">1  Visualizing Disease in the Early Modern Period</a></p>
<p class="toc"><a class="xref" href="#/chiBertoloniMeli0011#ch02">2  “Sic nata est anatome pathologica picta”: The Diseases of Bones</a></p>
<p class="toc"><a class="xref" href="#/chiBertoloniMeli0012#ch03">3  Preserved Specimens and Comprehensive Treatises</a></p>
<p class="toc"><a class="xref" href="#/chiBertoloniMeli0013#ch04">4  Intermezzo: Identifying Disease in Its Inception</a></p>
<p class="toc"><a class="xref" href="#/chiBertoloniMeli0014#ch05">5  The Nosology of Cutaneous Diseases</a></p>
<p class="toc"><a class="xref" href="#/chiBertoloniMeli0015#ch06">6  Morbid Anatomy in Color</a></p>
<p class="toc"><a class="xref" href="#/chiBertoloniMeli0016#ch07">7  Comprehensive Treatises in Color</a></p>
<p class="tocbmf"><a class="xref" href="#/chiBertoloniMeli0017#ch08">Concluding Reflections</a></p>
<p class="tocbm"><a class="xref" href="#/chiBertoloniMeli0018#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chiBertoloniMeli0019#ill_cred">Illustration Credits</a></p>
<p class="tocbm"><a class="xref" href="#/chiBertoloniMeli0020#abbrs">List of Abbreviations</a></p>
<p class="tocbm"><a class="xref" href="#/chiBertoloniMeli0021#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chiBertoloniMeli0022#biblio">Bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/chiBertoloniMeli0023#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Bertoloni-Meli-0007.vue?648a3400